export default {
  'cart:ch:free-shipping': 'Ab CHF 100 versenden wir Deine Lieferung kostenfrei!',
  'cart:summary:shipping:free-test': '<div><span>CHF 9.95</span>CHF 0.00</div>',
  'cart:shipping:existing-customer': 'Lieferkosten <span>(Kostenlos ab CHF 100)</span>',
};
